import { createSelectorCreator, defaultMemoize } from "reselect";
import Objects from "utils/Objects";

const deepEqualSelector = createSelectorCreator(
  defaultMemoize,
  Objects.checkDeepEqualityByHash
);

export default class Selectors {
  static createDeepEqualSelector(...args) {
    return deepEqualSelector(...args);
  }
}
